export const POLLING_SESSION_STORAGE_KEY = "massActionPolling";
